export default {
      id: "ic_report_green-usage",
      viewBox: "0 0 42 42",
      url: "/" + "images/icons.3.109.2.svg#ic_report_green-usage",
      toString: function () {
        return this.url;
      }
    }